'use client';

import { faArrowUp, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'use-intl';

import { isSurveyExpiredError } from '@/shared-utilities';

import { ProjectResponseSendComponentProps } from './project-response-renderer.type';

export default function ProjectResponseUsabilityNextButton({
  onSubmit,
  isSubmitting,
}: ProjectResponseSendComponentProps) {
  const t = useTranslations('UserTest');

  const handleClick = async () => {
    if (!onSubmit || isSubmitting) return;
    try {
      await onSubmit({ content: '' });
    } catch (error) {
      if (!isSurveyExpiredError(error)) throw error;
    }
  };

  return (
    <button
      type='button'
      onClick={handleClick}
      disabled={isSubmitting}
      className='flex w-full flex-1 items-center justify-center gap-3 rounded-2xl bg-gray-900 px-6 py-4 text-center transition-all hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-50'
      data-test='usability-next-button'
    >
      {isSubmitting ? (
        <FontAwesomeIcon
          icon={faSpinner}
          className='size-5 animate-spin text-white'
        />
      ) : (
        <>
          <FontAwesomeIcon
            icon={faArrowUp}
            className='relative h-3 w-2.5 text-white'
          />
          <div className='h-4'>
            <span className='block text-center [font-family:var(--brand-font)] text-xs font-medium text-white'>
              {t('doneContinue')}
            </span>
          </div>
        </>
      )}
    </button>
  );
}
